<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiLockOpen } from "@mdi/js";
export default {
  name: "MdiLockOpen",
  data() {
    return {
      svgPath: mdiLockOpen,
    };
  },
};
</script>
